// extracted by mini-css-extract-plugin
export var addButton = "_fu-0";
export var border = "_fu-8";
export var check = "_fu-h";
export var danger = "_fu-6";
export var dropdownContainer = "_fu-1";
export var editModalBody = "_fu-j";
export var footerContainer = "_fu-i";
export var fullWidth = "_fu-a";
export var hide = "_fu-9";
export var icon = "_fu-3";
export var input = "_fu-7";
export var inputFlex = "_fu-b";
export var inputWrapper = "_fu-c";
export var manualFocus = "_fu-5";
export var optionButton = "_fu-4";
export var pillWrapper = "_fu-e";
export var pointer = "_fu-2";
export var showOverflow = "_fu-f";
export var tagsFlex = "_fu-d";
export var xButton = "_fu-g";